module.exports = __webpack_public_path__ + "img/Proofsheet - Green - Selected.ad576fae.png";